import "./index.less";

import React from "react";
import { observer } from "mobx-react-lite";
import { Panel } from "@/components";
import Shop from "@/scenes/Login/enum/Shop";
import ShopType from "@/enum/ShopType";
import RenewalItem from "./RenewalItem";

interface RenewalProps {}

/**
 * 续费页面 （根据店铺类型选择跳转）
 */
const Renewal: React.FC<RenewalProps> = observer(function (props) {
    return (
        <div className="renewal-page">
            <Panel title="发货易续费">
                <div className="body">
                    {Object.keys(Shop).map((shopType: string | (ShopType & {})) => {
                        return <RenewalItem shopType={shopType} key={shopType} />;
                    })}

                    {[
                        ShopType.FKW,
                        ShopType.FKMDT,
                        ShopType.HKMDXT,
                        ShopType.WSC,
                        ShopType.DOUBB,
                        ShopType.INDEPENDENT_MANUAL,
                    ].map((shopType) => {
                        return <RenewalItem shopType={shopType} key={shopType} />;
                    })}
                </div>
            </Panel>
        </div>
    );
});

export default Renewal;
